

























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import AuthorizationService from '@auth/services/authorization.service';
import router from '@app/router/index.APP_TARGET';

@Component({
  name: 'bpc-header-admin-calendar-switch',
})
export default class HeaderAdminCalendarSwitch extends Vue {
  @Prop({ type: String, default: 'public' }) readonly layout: string;

  get isAdminLayout(): boolean {
    return this.layout == 'admin';
  }

  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get tenantAlias(): string {
    const tenant = this.$authService.getSelectedTenant();
    return tenant.alias || 't';
  }

  get tenantAliasParams() {
    return {
      tenantAlias: this.tenantAlias,
    };
  }

  get publicRoute() {
    return this.$clientRouter.getClientUrl(`/`);
  }

  goToAdminHomePage() {
    const $authorizationService = new AuthorizationService();
    router.push($authorizationService.getRedirectToHomePage());
  }
}
